import React from "react";
import { GrcCard, ragColor } from "./shared";
import { Badge } from "@/components/ui/badge";

const bandColor = (band) => {
  const b = String(band || "").toUpperCase();
  if (b === "HIGH") return "#D32F2F";
  if (b === "MEDIUM") return "#F57C00";
  if (b === "LOW") return "#388E3C";
  return "#64748B";
};

export const SDFCard = ({ sdf }) => {
  const s = sdf || {};
  return (
    <GrcCard
      title="SDF Readiness (P9)"
      info="Significant Data Fiduciary screening. Module A estimates designation likelihood; Module B measures obligation readiness (used as P9's score — Rule #4)."
      infoTestId="info-sdf"
      testId="card-sdf"
    >
      <div className="flex flex-col items-center gap-3">
        <Badge
          data-testid="sdf-flag-badge"
          className={
            s.flag
              ? "bg-amber-100 text-amber-800 hover:bg-amber-100 border border-amber-300"
              : "bg-slate-100 text-slate-600 hover:bg-slate-100 border border-slate-200"
          }
        >
          {s.flag ? "SDF APPLICABLE" : "SDF NOT APPLICABLE"}
        </Badge>
        <div className="grid grid-cols-2 gap-2 w-full">
          <div className="rounded-lg border border-slate-200 p-2.5 text-center">
            <div className="text-[11px] font-semibold text-slate-600">Module A</div>
            <div className="text-[10px] text-slate-400 mb-1">Probability Band</div>
            <div data-testid="sdf-module-a-band" className="text-base font-bold" style={{ color: bandColor(s.module_a_band) }}>
              {s.module_a_band || "N/A"}
            </div>
            <div className="text-[10px] text-slate-400 mt-1">Designation likelihood</div>
          </div>
          <div className="rounded-lg border border-slate-200 p-2.5 text-center">
            <div className="text-[11px] font-semibold text-slate-600">Module B</div>
            <div className="text-[10px] text-slate-400 mb-1">Readiness Score</div>
            <div data-testid="sdf-module-b-score" className="text-base font-bold" style={{ color: ragColor(s.module_b_rag || "YELLOW") }}>
              {s.module_b_score != null ? `${s.module_b_score}%` : "N/A"}
            </div>
            <div className="text-[10px] text-slate-400 mt-1">Obligation readiness</div>
          </div>
        </div>
        {s.module_b_activated && (
          <span
            data-testid="sdf-module-b-activated"
            className="text-[11px] font-medium px-2.5 py-1 rounded-full bg-[#FBC02D]/15 text-[#B8860B]"
          >
            Module B Activated
          </span>
        )}
      </div>
    </GrcCard>
  );
};
